
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'Button',
    props: {
        color: String,
        text: String,
    },
    emits: ['on-click']
})
